import * as ep from "../../../../endpoints";
import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
function mapEventFormData(form) {
  const fd = new FormData();
  for (const key in form) {
    if (Object.hasOwnProperty.call(form, key)) {
      const element = form[key];
      if (key === "image_event" && typeof element === "string") continue;
      if(element)
        fd.append(key, element);
    }
  }
  if (form.id) fd.append("_method", "PUT");

  return fd;
}
export default {
  namespaced: true,
  state: {
    events: [],
    loading: false,
    working: false,
    pagination: {},
  },
  getters: {
    events(state) {
      return state.events;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setEvents(state, payload) {
      state.events = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async getEvents({ commit }, payload) {
      commit("setLoading", true);
      await api
        .get(ep.EVENTS, { params: { page: payload.page } })
        .then((res) => {
          commit("setEvents", res.data.data);
          commit("setPagination", res.data.pagination);
        });
      commit("setLoading", false);
    },

    async createEvent({ commit, dispatch }, { form, page }) {
      commit("setWorking", true);
      try {
        var toSend = mapEventFormData(form);
        const res = await api.post(ep.EVENTS, toSend);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getEvents", { page: page });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async updateEvent({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        var toSend = mapEventFormData(payload.form);
        const res = await api.post(ep.EVENT_BY_ID(payload.form.id), toSend);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getEvents", { page: payload.page });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteEvent({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.delete(ep.EVENT_BY_ID(payload.id));

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getEvents", { page: payload.page });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
